import { CircleCloseFilled, QuestionFilled, SuccessFilled, WarningFilled } from '@element-plus/icons-vue';
export default {
  name: "AuditState",
  components: {
    SuccessFilled,
    WarningFilled,
    CircleCloseFilled,
    QuestionFilled
  },
  props: {
    state: Number
  }
};